jQuery(function($) {
    $('.dropdown > a').click(function(){
        location.href = this.href;
    });
});
